export default __webpack_public_path__ + "static/media/food3.efaa2de8.jpg";